// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.card-container[data-v-5458dc7a]:first-child{border-top:1px solid var(--border-primary)}.card-container:hover .title[data-v-5458dc7a]{color:red}.footer[data-v-5458dc7a]{margin-top:32px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
